import React from "react";
import { Droplets, Zap, Flame, Wrench, ArrowUpRight, Siren } from "lucide-react";
import { useApp } from "@/context/AppContext";

const ICONS = {
  plumbing: Droplets,
  electric: Zap,
  heating: Flame,
  remod: Wrench,
  urgencias: Siren,
};

export default function Services() {
  const { t } = useApp();

  return (
    <section id="servicios" data-testid="services-section" className="ht-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="ht-eyebrow">{t.services.eyebrow}</p>
          <h2
            className="mt-3 text-3xl font-bold sm:text-4xl"
            style={{ color: "var(--ht-text)" }}
            data-testid="services-title"
          >
            {t.services.title}
          </h2>
          <p className="mt-4 text-base" style={{ color: "var(--ht-text-muted)" }}>
            {t.services.subtitle}
          </p>
        </div>

        <div className="ht-stagger mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {t.services.items.map((item) => {
            const Icon = ICONS[item.key] || Wrench;
            const isUrgent = item.key === "urgencias";
            return (
              <a
                key={item.key}
                href="#contacto"
                data-testid={`service-card-${item.key}`}
                className="ht-card group relative flex flex-col gap-4 p-6"
              >
                <span
                  className="inline-flex h-12 w-12 items-center justify-center rounded-lg"
                  style={{
                    backgroundColor: isUrgent
                      ? "rgba(var(--ht-accent-rgb), 0.12)"
                      : "rgba(27, 104, 178, 0.1)",
                    color: isUrgent ? "var(--ht-accent)" : "var(--ht-primary)",
                  }}
                >
                  <Icon size={22} />
                </span>
                <div className="flex items-center gap-2">
                  <h3 className="text-lg font-semibold" style={{ color: "var(--ht-text)" }}>
                    {item.title}
                  </h3>
                  {isUrgent && (
                    <span
                      className="ht-pulse inline-flex h-2 w-2 rounded-full"
                      style={{ backgroundColor: "var(--ht-accent)" }}
                      aria-hidden
                    />
                  )}
                </div>
                <p className="text-sm leading-relaxed" style={{ color: "var(--ht-text-muted)" }}>
                  {item.desc}
                </p>
                <ArrowUpRight
                  size={18}
                  className="absolute right-5 top-5 opacity-0 transition-opacity group-hover:opacity-100"
                  style={{ color: "var(--ht-accent)" }}
                />
              </a>
            );
          })}
        </div>

        {/* Disclaimer footnote */}
        <p
          className="mt-8 text-sm italic"
          style={{ color: "var(--ht-text-muted)" }}
          data-testid="services-disclaimer"
        >
          {t.services.disclaimer}
        </p>
      </div>
    </section>
  );
}
